import PaymentType from '@/model/PaymentType';

export enum CheckoutStep {
  INFORMATION,
  CLIENT_DATA,
  ADDRESS,
  PAYMENT_VALUE,
  PAYMENT_CHOICE,
  PAYMENT,
  FINISHED,
}

export interface EventCheckout {
  name: string;
  image: string;
  startDate: Date;
  city: string;
  state: string;
}

export interface TicketCheckout {
  id: string;
  name: string;
  value: number;
  amount: number;
}

export enum FormInputNameClient {
  cpf = 'cpf',
  email = 'email',
  phone = 'phone',
}

export enum FormInputNameAddress {
  zipCode = 'zipCode',
  state = 'state',
  city = 'city',
  district = 'district',
  street = 'street',
  complement = 'complement',
  number = 'number',
}

export enum FormInputNamePayment {
  clientId = 'clientId',
  paymentFractionalValue = 'paymentFractionalValue',
  paymentValue = 'paymentValue',
  paymentType = 'paymentType',
  installments = 'installments',
  paymentValueWithFee = 'paymentValueWithFee',
}

export enum FormInputNameCreditCard {
  number = 'number',
  month = 'month',
  year = 'year',
  cvv = 'cvv',
  name = 'name',
  document = 'document',
}

export interface PaymentTab {
  text: string;
  icon: React.ReactNode;
  type: PaymentType;
}

export interface PaymentContent {
  content: React.ReactNode;
  type: PaymentType;
}
